import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { apiGetQuotePromotionAllReleatedDetailInformation, apiGetQuotePromotionMemberList } from '../combineApi';
export var apiGetQuotePromotionAllDetailInformationByQuoteId = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
    var promotionInfo, _promotionRes$data, _promotionRes$data2, _yield$apiGetQuotePro, _yield$apiGetQuotePro2, promotionRes, oneMemberItem, _memberListRes$data, _yield$apiGetQuotePro3, _yield$apiGetQuotePro4, memberListRes, _ref2, firstName, lastName, email, phone, _ref3, memberFirstName, memberLastName, memberEmail, memberPhone, brokerFirstName, brokerLastName, brokerEmail, brokerPhone;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promotionInfo = null;
            _context.prev = 1;
            _context.next = 4;
            return apiGetQuotePromotionAllReleatedDetailInformation({
              quoteId: config === null || config === void 0 ? void 0 : config.quoteId
            });

          case 4:
            _yield$apiGetQuotePro = _context.sent;
            _yield$apiGetQuotePro2 = _slicedToArray(_yield$apiGetQuotePro, 1);
            promotionRes = _yield$apiGetQuotePro2[0];
            oneMemberItem = null;

            if (!(config !== null && config !== void 0 && config.promotionId)) {
              _context.next = 15;
              break;
            }

            _context.next = 11;
            return apiGetQuotePromotionMemberList({
              promotionId: config.promotionId
            });

          case 11:
            _yield$apiGetQuotePro3 = _context.sent;
            _yield$apiGetQuotePro4 = _slicedToArray(_yield$apiGetQuotePro3, 1);
            memberListRes = _yield$apiGetQuotePro4[0];
            oneMemberItem = memberListRes === null || memberListRes === void 0 ? void 0 : (_memberListRes$data = memberListRes.data) === null || _memberListRes$data === void 0 ? void 0 : _memberListRes$data[0];

          case 15:
            _ref2 = oneMemberItem || {}, firstName = _ref2.firstName, lastName = _ref2.lastName, email = _ref2.email, phone = _ref2.phone;
            _ref3 = (promotionRes === null || promotionRes === void 0 ? void 0 : promotionRes.data) || {}, memberFirstName = _ref3.memberFirstName, memberLastName = _ref3.memberLastName, memberEmail = _ref3.memberEmail, memberPhone = _ref3.memberPhone, brokerFirstName = _ref3.brokerFirstName, brokerLastName = _ref3.brokerLastName, brokerEmail = _ref3.brokerEmail, brokerPhone = _ref3.brokerPhone;
            promotionInfo = _objectSpread(_objectSpread({}, promotionRes === null || promotionRes === void 0 ? void 0 : promotionRes.data), {}, {
              id: config === null || config === void 0 ? void 0 : config.promotionId,
              defaultBrokerName: memberFirstName ? "".concat(memberFirstName, " ").concat(memberLastName) : brokerFirstName ? "".concat(brokerFirstName, " ").concat(brokerLastName) : firstName ? "".concat(firstName, " ").concat(lastName) : '',
              defaultBrokerEmail: memberEmail || brokerEmail || email || '',
              defaultBrokerPhone: memberPhone || brokerPhone || phone || '',
              logo: _objectSpread({}, promotionRes === null || promotionRes === void 0 ? void 0 : (_promotionRes$data = promotionRes.data) === null || _promotionRes$data === void 0 ? void 0 : _promotionRes$data.partnerLogo),
              payload: promotionRes === null || promotionRes === void 0 ? void 0 : (_promotionRes$data2 = promotionRes.data) === null || _promotionRes$data2 === void 0 ? void 0 : _promotionRes$data2.promotionPayload
            });
            _context.next = 22;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](1);

          case 22:
            return _context.abrupt("return", promotionInfo);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 20]]);
  }));

  return function apiGetQuotePromotionAllDetailInformationByQuoteId(_x) {
    return _ref.apply(this, arguments);
  };
}();